interface ILegendSwatch {
  label: string;
  swatchClass: string;
}

const CARDINALITY_SWATCHES: ILegendSwatch[] = [
  { label: '1:*', swatchClass: 'bg-teal-700' },
  { label: '1:1', swatchClass: 'bg-blue-700' },
  { label: '*:*', swatchClass: 'bg-purple-600' },
  { label: 'unknown', swatchClass: 'bg-slate-500' },
];

const ROLE_SWATCHES: ILegendSwatch[] = [
  { label: 'fact', swatchClass: 'bg-blue-600' },
  { label: 'dim', swatchClass: 'bg-green-600' },
  { label: 'other', swatchClass: 'bg-slate-500' },
];

export function BimGraphLegend() {
  return (
    <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-[11px] text-muted-foreground">
      <div className="flex items-center gap-2">
        <span className="font-medium text-foreground">Cardinality:</span>
        {CARDINALITY_SWATCHES.map((swatch) => (
          <span key={swatch.label} className="flex items-center gap-1">
            <span className={`inline-block h-0.5 w-4 ${swatch.swatchClass}`} aria-hidden="true" />
            {swatch.label}
          </span>
        ))}
      </div>
      <div className="flex items-center gap-2">
        <span className="font-medium text-foreground">Table:</span>
        {ROLE_SWATCHES.map((swatch) => (
          <span key={swatch.label} className="flex items-center gap-1">
            <span className={`inline-block h-2.5 w-2.5 rounded-sm ${swatch.swatchClass}`} aria-hidden="true" />
            {swatch.label}
          </span>
        ))}
      </div>
      <span className="flex items-center gap-1">
        <span className="inline-block h-0.5 w-4 border-t border-dashed border-muted-foreground" aria-hidden="true" />
        inactive
      </span>
    </div>
  );
}
